import React, { Component } from 'react'
// CSS
import './App.css'

import Header from './components/Header'
import Admin from './components/Admin'
import Card from './components/Card'


import withFirebase from './hoc/withFirebase'

import ColorContext from './components/Color'

const App = ({
  match,
  supprimerRecette,
  recettes,
  majRecette,
  ajouterRecette,
  chargerExemple
}) => {
  const cards = Object.keys(recettes)
      .map(key => <Card key={key} details={recettes[key]} />)
    console.log(cards)

    return (

      <ColorContext>
        <div className='box'>
          <Header pseudo={match.params.pseudo} ></Header>
          <div className='cards'>
              { cards }
          </div>
          <Admin 
            pseudo={match.params.pseudo}
            supprimerRecette={supprimerRecette}
            recettes={recettes}
            majRecette={majRecette}
            ajouterRecette={ajouterRecette}
            chargerExemple={chargerExemple} ></Admin>
        </div>  
      </ColorContext>
    
    )
}


const WrappedComponent = withFirebase(App)

export default WrappedComponent
